import { useBackend } from "../../services";

export const useGetPasskeyRegistrationOptions = () => {
  const { get } = useBackend();
  return async () => {
    return await get("passkeys/registration");
  };
};
